import React, { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.scss';
import cn from 'classnames';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  className?: string;
  labelClassName?: string;
  primary?: boolean;
  secondary?: boolean;
  vanished?: boolean;
  red?: boolean;
  green?: boolean;
  small?: boolean;
  short?: boolean;
  left?: boolean;
  right?: boolean;
  square?: boolean;
  noMargins?: boolean;
  icon?: JSX.Element;
  iconLeft?: JSX.Element;
}

function Button(props: ButtonProps) {
  const {
    label = '',
    className,
    icon,
    iconLeft,
    primary,
    secondary,
    vanished,
    red,
    green,
    small,
    short,
    left,
    right,
    square,
    noMargins,
    labelClassName,
    ...rest
  } = props;

  let buttonClassName = cn(styles.container, className);
  if (primary) {
    buttonClassName = cn(buttonClassName, styles.primary);
  }

  if (secondary) {
    buttonClassName = cn(buttonClassName, styles.secondary);
  }

  if (vanished) {
    buttonClassName = cn(buttonClassName, styles.vanished);
  }

  if (red) {
    buttonClassName = cn(buttonClassName, styles.red);
  }

  if (green) {
    buttonClassName = cn(buttonClassName, styles.green);
  }

  if (small) {
    buttonClassName = cn(buttonClassName, styles.small);
  }

  if (short) {
    buttonClassName = cn(buttonClassName, styles.short);
  }

  if (left) {
    buttonClassName = cn(buttonClassName, styles.left);
  }

  if (right) {
    buttonClassName = cn(buttonClassName, styles.right);
  }

  if (square) {
    buttonClassName = cn(buttonClassName, styles.square);
  }

  if (noMargins) {
    buttonClassName = cn(buttonClassName, styles.noMargins);
  }

  return (
    <button type={'button'} className={buttonClassName} {...rest}>
      {!!iconLeft && <div className={styles.iconLeft}>{iconLeft}</div>}
      <span className={cn(styles.label, labelClassName)}>{label}</span>
      {!!icon && <div className={styles.iconRight}>{icon}</div>}
    </button>
  );
}

export default Button;
